import React, {Fragment} from 'react';
import _ from 'lodash';

import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';

import FieldWrap from '../../Common/FieldWrap';
import ScheduleTable from '../../Common/ScheduleTable';
import locales from '../../../locales';
import {IRestaurantWorkTimes} from '../../../types/IScheduleStore';
import CustomTooltip from '../../Common/CustomTooltip';

interface IProps {
  isActiveRestaurantSchedule?: boolean;
  label?: string;
  handleSwitchReserveSchedule: any;
  restaurantWorkTimes: IRestaurantWorkTimes;
}

/**
 * @param classes
 * @param handleSwitchReserveSchedule - Ручка для переключения типа приёма расписания приёма резервов
 */
const AutoBookingSwitch: React.FC<IProps> = ({
  label,
  isActiveRestaurantSchedule,
  handleSwitchReserveSchedule,
  restaurantWorkTimes,
}) => {
  const activeType = isActiveRestaurantSchedule === undefined ? ''
    : isActiveRestaurantSchedule
      ? locales.t('settings.reserveSchedule.restaurantSchedule')
      : locales.t('settings.reserveSchedule.customSettings');

  const disable = _.isEmpty(restaurantWorkTimes);

  return (
    <Fragment>
      <FieldWrap>
        <FormControl fullWidth>
          <InputLabel>{label}</InputLabel>
          <Select
            disabled={isActiveRestaurantSchedule === undefined}
            onChange={handleSwitchReserveSchedule}
            value={activeType}
          >
            {
              [
                locales.t('settings.reserveSchedule.restaurantSchedule'),
                locales.t('settings.reserveSchedule.customSettings'),
              ]
                .map((items, i) => (
                  <MenuItem
                    disabled={disable ? i === 1 : false}
                    key={i}
                    value={items}
                  >
                    {items}
                  </MenuItem>
                ))
            }
          </Select>
        </FormControl>
        <CustomTooltip marginLeft content="" />
      </FieldWrap>
      {
        (isActiveRestaurantSchedule === false)
        && (
          <div style={{padding: '0 24px'}}>
            <ScheduleTable
              restaurantWorkTimes={restaurantWorkTimes}
              type={'booking'}
            />
          </div>
        )
      }
    </Fragment>
  );
};

export default AutoBookingSwitch;
